import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { DeliveryAreaService } from '../delivery-area.service';
import { DeliveryEventsService } from './delivery-events.service';
import { DeliveryEventsTab1Part } from './tabs/tab-1/delivery-events-tab-1.part';
import { DeliveryEventsTab2Part } from './tabs/tab-2/delivery-events-tab-2.part';
import { DeliveryEventsViewsPart } from './views/events-views.part';

@Component({
	selector: 'delivery-events-page',
	standalone: true,
	imports: [
		DeliveryEventsTab1Part, DeliveryEventsTab2Part, DeliveryEventsViewsPart,
		PageTab1Directive, PageTab2Directive, PageTab3Directive,
		PageTabsWidget,
		TrimesterDroplistWidget, DroplistWidget, ToolbarWidget,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './delivery-events.page.html',
})
export class DeliveryEventsPage implements OnInit {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Programming;
	public deliveryService = inject(DeliveryAreaService);
	public pageService = inject(DeliveryEventsService);


	async ngOnInit() {
		await this.deliveryService.loadDeliveryData();
	}


	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}